import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import { BIKE_PRICE_TAX_DISCLAIMER } from '../utils'

const Banner = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  padding: 1.25rem 1.25rem;
  border-radius: 0.5rem;
  background-color: ${palette.secondary.purple100};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const BannerText = styled(Text)`
  font-size: 1rem;
  line-height: 1.5rem;
`

export const BIKE_WAITLIST_SECTION_ID = 'bike-waitlist'

interface BikeCatalogInfoBannerProps {
  subsidyAmountLabel: string
}

const BikeCatalogInfoBanner = React.memo(
  (props: BikeCatalogInfoBannerProps) => {
    const { subsidyAmountLabel } = props

    return (
      <Banner>
        <BannerText variant='body1' textColor={palette.secondary.purple900}>
          <strong>Choose your bike below.</strong> Click{' '}
          <strong>Checkout</strong> to advance to the checkout process with the
          vendor. The vendor will already apply your {subsidyAmountLabel} subsidy
          at their checkout. You will need to add your card at their checkout to
          pay for any additional funds over the {subsidyAmountLabel} subsidy.
        </BannerText>
        <BannerText variant='body1' textColor={palette.secondary.purple900}>
          <strong>Tax:</strong> {BIKE_PRICE_TAX_DISCLAIMER}
        </BannerText>
      </Banner>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  BikeCatalogInfoBanner.displayName = 'BikeCatalogInfoBanner'
}

export default BikeCatalogInfoBanner
